/* eslint-disable */
export default {
  tollFree: 'Maksuton',
  rcvPmiMeetingTitle: '{extensionName} – videotapaaminen',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
